import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import LocationSearchErrorMessage from './presentionalComponents/LocationSearchErrorMessage';
import LocationFoundBlock from './presentionalComponents/LocationFoundBlock';
import LocationSearchBlock from './LocationSearchBlock';
import { clearLocation } from '../../locationSearchHelpers';
import translations from '../../translations';

class LocationBlock extends PureComponent {

  render() {
    const {
      name,
      errorMessage,
      currentFoundLocation,
      locationServiceLoading,
      pending,
      isMobile
    } = this.props;

    if (locationServiceLoading) {
      return null;
    } if (errorMessage) {
      // error message when an error occurs
      return (
        <div className={'dc-location-block'}>
          <LocationSearchErrorMessage
            errorMessageLabel={errorMessage}
            linkLabel={translations.searchAgainLink}
            onLinkClick={(e) => {
              e.preventDefault();
              clearLocation();
            }}
          />
        </div>
      );
    } if (currentFoundLocation && !pending) {
      // location found component -
      // displayed only when location found AND is not pending
      return (
        <div className={'dc-location-block'}>
          <LocationFoundBlock
            locationFoundLabel={
              (name === 'above product listing')
                ? translations.locationFoundTopSearchLabel
                : translations.locationFoundFilterSearchLabel
            }
            locationName={currentFoundLocation.location}
            linkLabel={translations.changeLocationLink}
            onLinkClick={(e) => {
              e.preventDefault();
              clearLocation();
            }}
            orientation={(name === 'above product listing' && !isMobile)
              ? 'horizontal'
              : 'vertical'}
          />
        </div>

      );
    }
    // search input with/without geolocate
    return (
      <div className={'dc-location-block'}>
        <LocationSearchBlock
          name={name}
        />
      </div>
    );

  }
}

LocationBlock.propTypes = {
  // DON'T CHANGE THE VALUES of the following prop, the format is due to analytics
  name: PropTypes.oneOf([
    'above product listing',
    'filter block'
  ]).isRequired,
  errorMessage: PropTypes.string.isRequired,
  locationServiceLoading: PropTypes.bool.isRequired,
  pending: PropTypes.bool.isRequired,
  currentFoundLocation: PropTypes.shape({
    location: PropTypes.string.isRequired,
    postcode: PropTypes.string.isRequired
  }),
  isMobile: PropTypes.bool.isRequired
};

LocationBlock.defaultProps = {
  currentFoundLocation: null
};

function mapStateToProps(state) {
  return {
    errorMessage: state.listingPage.locationSearch.errorMessage,
    currentFoundLocation: state.listingPage.locationSearch.currentFoundLocation,
    locationServiceLoading: state.listingPage.locationSearch.locationServiceLoading,
    pending: state.listingPage.locationSearch.pending,
    isMobile: state.general.device.deviceType === 'mobile'
  };
}

export default connect(mapStateToProps)(LocationBlock);
